import { CheckboxProps, Stack } from '@shopify/polaris';
import { FunctionComponent, useCallback } from 'react';
import CheckboxInput from '@ui/checkbox';

export interface CheckboxStackProps {
  onChange?: (status: boolean, id: string) => void;
  buttons: CheckboxProps[];
}

const CheckboxStack: FunctionComponent<CheckboxStackProps> = ({
  buttons,
  onChange,
}) => {
  const handleChange = useCallback(
    (_checked, newValue) => {
      if (onChange) {
        onChange(_checked, newValue);
      }
    },
    [onChange],
  );

  return (
    <Stack vertical spacing="extraTight">
      {buttons.map(({ id, ...props }: CheckboxProps) => (
        <CheckboxInput key={id} id={id} onChange={handleChange} {...props} />
      ))}
    </Stack>
  );
};

export default CheckboxStack;
